import { isEmpty } from "lodash";

export function stringNull(data) {
    return !isEmpty(data) ? data : "";
}
export function numberValue(data) {
    return !isEmpty(data) ? data : 0;
}
export function boolValueTrue(data) {
    return !isEmpty(data) ? data : true;
}
export function boolValueFalse(data) {
    return !isEmpty(data) ? data : false;
}
/// <summary>
/// بررسی اینکه آیا مقدار وجود داره یا خیر
/// </summary>
/// <param name="value"></param>
/// <param name="ignoreWhiteSpace"></param>
/// <returns></returns>
export function HasValue(value, ignoreWhiteSpace = true) {
    return ignoreWhiteSpace ? !value?.trim().length === 0 : !!value;
}
/// <summary>
/// تبدیل به Int
/// </summary>
/// <param name="value"></param>
/// <returns></returns>
export function ToInt(data) {
    return !isEmpty(data) ? parseInt(data, 10) : 0;
}
/// <summary>
/// تبدیل به Decimal
/// </summary>
/// <param name="value"></param>
/// <returns></returns>
export function toDecimal(value) {
    return !isEmpty(value) ? parseFloat(value) : 0;
}
/// <summary>
/// دریافت مقدار
/// int
/// و نمایش آن به صورت سه رغم اعشار
/// </summary>
/// <param name="value"></param>
/// <returns></returns>
export function toNumeric(value) {
    return value.toLocaleString() + " تومان";
}
/// <summary>
/// دریافت مقدار
/// int
/// و نمایش آن به صورت
/// Currency
/// </summary>
/// <param name="value"></param>
/// <returns></returns>
export function toCurrency(value) {
    return value.toLocaleString(undefined, { style: "currency", currency: "IRR" });
}
/// <summary>
/// جایگزین عدد فارسی به جای انگلیسی
/// </summary>
/// <param name="str"></param>
/// <returns></returns>
export function En2Fa(str) {
    if (str == null) {
        str = "۰";
    }

    const enToFaMap = {
        "0": "۰",
        "1": "۱",
        "2": "۲",
        "3": "۳",
        "4": "۴",
        "5": "۵",
        "6": "۶",
        "7": "۷",
        "8": "۸",
        "9": "۹",
    };

    return str.replace(/[0-9]/g, (match) => enToFaMap[match]);
}
/// <summary>
/// جایگزین عدد انگلیسی به جای فارسی
/// </summary>
/// <param name="str"></param>
/// <returns></returns>
export function fa2En(str) {
    if (str == null) {
        str = "0";
    }

    const faToEnMap = {
        "۰": "0",
        "۱": "1",
        "۲": "2",
        "۳": "3",
        "۴": "4",
        "۵": "5",
        "۶": "6",
        "۷": "7",
        "۸": "8",
        "۹": "9",
        "٠": "0",
        "١": "1",
        "٢": "2",
        "٣": "3",
        "٤": "4",
        "٥": "5",
        "٦": "6",
        "٧": "7",
        "٨": "8",
        "٩": "9",
    };

    return str.replace(/[\u06F0-\u06F9\u0660-\u0669]/g, (match) => faToEnMap[match]);
}
/// <summary>
/// جایگزین حروف فارسی به جای حروف عربی و غیر ایرانی
/// </summary>
/// <param name="str"></param>
/// <returns></returns>
export function fixPersianChars(str) {
    if (str == null || str === "string") {
        str = " ";
    }

    const wrongCharsToCorrect = {
        "ﮎ": "ک",
        "ﮏ": "ک",
        "ﮐ": "ک",
        "ﮑ": "ک",
        "ك": "ک",
        "ي": "ی",
        " ": " ",
        "‌": " ",
        "ھ": "ه",
    };

    // اضافه کردن موارد جدید به تابع
    //wrongCharsToCorrect["ئ"] = "ی";

    return str.replace(/./g, (char) => wrongCharsToCorrect[char] || char);
}
/// <summary>
/// حذف نقطه یا علامت اعشار از اعداد
/// </summary>
/// <param name="str"></param>
/// <returns></returns>
export function removePoint(str) {
    if (str == null || str === "") {
        str = "0";
    }
    return str
        .replace(/[,./.]/g, "") // حذف کاراکترهای , / و .
        .fa2En() // تبدیل عدد فارسی به انگلیسی
        .trim(); // حذف فاصله‌های اضافی از ابتدا و انتهای رشته
}
// تابع کمکی برای حذف تگ‌های HTML از رشته
export function removeHtmlTags(source) {
    const pattern = /<[^>]*(>|$)|&zwnj;|&raquo;|&laquo;/g;
    return source.replace(/&nbsp;/g, " ").trim().replace(pattern, "");
}
// تابع کمکی برای حذف مقادیر عملکر گردها از رشته
export function removeSpecialCharacters(source) {
    const pattern = /\r\n/g;
    return source.trim().replace(pattern, " ");
}